export default "__VITE_ASSET__CfV6Auk$__"